import PerfectDayLogo from "@components/PerfectDayLogo"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"

export default function LoginHeader() {
  const { t } = useTranslation()

  return (
    <header className="custom-container flex shrink-0 items-center justify-between py-8">
      <PerfectDayLogo />

      <Link
        className="text-lg font-bold hover:opacity-80"
        to="/account/sign-in"
      >
        {t("shared.signIn")}
      </Link>
    </header>
  )
}
